<script lang="ts" setup>
  import Divider from '~/components/UI/Others/Divider.vue';

  const props = defineProps<{
    title: string;
    stateKey?: string;
    checkboxCollection?: {
      name: string;
      checked: boolean;
      checkboxText: string;
    }[];
    isDisabled?: boolean;
    showOnly?: boolean;
    controlAdminEnabledBases?: any;
    systemAdmin?: boolean;
  }>();

  const localChecked = ref(props.checkboxCollection);
  const emit = defineEmits(['update:modelValue']);

  const handleCheckboxClick = (checkbox: any) => {
    if (props.isDisabled) return;
    checkbox.checked = !checkbox.checked;
  };

  const isCheckboxDisabled = (checkbox: any) => {
    if (props.isDisabled) return true;

    const isControl = checkbox.name.includes('approval_control_admin');

    if (props.systemAdmin) {
      return !isControl;
    }

    const normalized = checkbox.name.replace(/^_+/, '');
    const base = normalized
      .replace('_approval_control_admin', '')
      .replace('_admin', '')
      .replace('_approver', '')
      .replace('_submitter', '')
      .replace('_member', '');

    const moduleInfo = props.controlAdminEnabledBases?.[base];

    if (isControl) {
      if (!moduleInfo?.admin) return true;
      if (moduleInfo?.other) return true;
      return false;
    }

    return false;
  };

  watch(
    () => props.checkboxCollection,
    newValue => {
      localChecked.value = newValue;
    }
  );

  watch(
    () => localChecked.value,
    newValue => {
      emit('update:modelValue', props.stateKey, newValue);
    },
    { deep: true }
  );
</script>

<template>
  <div
    class="flex flex-col gap-4 p-3 rounded-lg bg-white border border-gray-200 shadow-[0px_1px_3px_0px_#0000001A,0px_1px_2px_0px_#0000000F]"
  >
    <p class="text-sm text-gray-600 font-bold">{{ props.title }}</p>
    <Divider />
    <div v-for="(checkbox, index) in localChecked" :key="index" class="flex flex-col gap-4">
      <a-checkbox
        :checked="checkbox.checked"
        :name="checkbox.name"
        class="text-sm text-gray-600 font-medium"
        :class="{ 'pointer-events-none': props.showOnly }"
        :disabled="isCheckboxDisabled(checkbox)"
        @click="handleCheckboxClick(checkbox)"
        >{{ checkbox.checkboxText }}</a-checkbox
      >
      <Divider v-if="(index + 1) % 4 === 0 && index !== (localChecked?.length ?? 0) - 1" />
    </div>
  </div>
</template>
